import script from "./AdminHome.vue?vue&type=script&setup=true&lang=js"
export * from "./AdminHome.vue?vue&type=script&setup=true&lang=js"

import "./AdminHome.vue?vue&type=style&index=0&id=30a3e8c6&lang=css"

const __exports__ = script;

export default __exports__